export default {"src":"/_next/static/media/ellipse5.ab3dcb3e.svg","height":176,"width":176};